var themingIsEnabled = false;
var darkModeIsEnabled = false;
export var setThemingIsEnabled = function (isEnabled) {
    themingIsEnabled = isEnabled;
};
export var setDarkModeIsEnabled = function (isEnabled) {
    darkModeIsEnabled = isEnabled;
};
// Task 4364092 Clean-up when 'SharedUXThemingIsEnabled' BRS and Flighting is cleaned-up
export function isThemingEnabled() {
    return themingIsEnabled;
}
export function isDarkModeEnabled() {
    return darkModeIsEnabled && themingIsEnabled;
}
//# sourceMappingURL=ThemingExperiment.js.map